import React from 'react';
import { ThemeProvider as Provider } from 'styled-components';

import { ThemeDefault } from './theme.default';
import { Theme } from './theme.types';

type ThemeHook = (theme: Theme) => Theme & Record<string, unknown>;

export type ThemeProviderOptions = {
  themeFinal?: ThemeHook;
};

export type ThemeProviderProps = {
  children: React.ReactNode;
  options?: ThemeProviderOptions;
  theme?: Theme;
};

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  // options,
  theme = ThemeDefault,
}) => {
  // Unused for now until we understand the impact of it on the React render cycle.
  // if (options?.themeFinal) {
  //   theme = options.themeFinal(theme);
  // }
  return <Provider theme={theme}>{children}</Provider>;
};
